//REACT
import React from 'react';
import ReactDOM from 'react-dom';
//REDUX
import { Provider } from 'react-redux';
import store from './store';
//ROUTER
import { Router, Route, IndexRedirect, hashHistory } from 'react-router';
//BASE GUI
import AppIndex from './components/App/AppIndex';
import AppError from './components/App/AppError';
//APP SECURE & LOGIN
import AppSecureContainer from './components/App/AppSecureContainer';
import AppLoginFormContainer from './components/App/AppLoginFormContainer';
//PROFILE CREATOR
import ProfileIndexContainer from './components/Profile/ProfileIndexContainer';

//MATERIAL-UI GUI WEB
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
//CSS
import { blue700, grey300, white } from 'material-ui/styles/colors';
import Colors from './theme/Colors';
import './index.css';

injectTapEventPlugin();

const muiTheme = getMuiTheme({
  fontFamily: 'CalibriBold',
  palette: {
    primary1Color: Colors.primary1Color,
    primary2Color: Colors.primary2Color,
    primary3Color: Colors.primary3Color,
    accent1Color: Colors.accent1Color,
    accent2Color: Colors.accent2Color,
    accent3Color: Colors.accent3Color,
    textColor: Colors.darkBlack,
    alternateTextColor: white,
    canvasColor: Colors.background,
    borderColor: grey300,
    pickerHeaderColor: blue700
  },
  appBar: {
    color: Colors.primary1Color,
    textColor: white
  }
});

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <Router history={hashHistory}>
        <Route path="/" component={AppIndex}>
          <IndexRedirect to="/profile" />
          <Route component={AppSecureContainer}>
            <Route path="/profile" component={ProfileIndexContainer} />
          </Route>
          <Route path="/login" component={AppLoginFormContainer} />
          <Route path="*" component={AppError} />
        </Route>
      </Router>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js